angular.module('moebiusProadapt').controller('ctrlParticipantEvaluationMaladie',
    ['$rootScope', '$scope', '$http', 'moment', '$timeout', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal','eti','questionVisite','participant','questionMere','linkedObject',
        function ($rootScope, $scope, $http, moment, $timeout, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, eti, questionVisite, participant, questionMere,linkedObject) {

    console.log(linkedObject);
            $scope.evaluationmaladie   = linkedObject;

            $scope.constants = $rootScope.constants;

            //modal informations to display
            $scope.title        = questionMere.name;
            $scope.titleConfirm = 'OK';
            if ($scope.evaluationmaladie.editOrSave === 'SAVE') {
                $scope.title        = $scope.title + '-' + 'Ajout';
                $scope.titleConfirm = 'Ajouter';

            } else {
                $scope.title        = $scope.title + '-' + 'Edition';
                $scope.titleConfirm = 'Modifier';
            }


            $scope.examensRadiologiquesList = [] ;
            _.each($scope.constants.examens_radiologiques_list.VALUES_TO_DISPLAY,function(value, key){
                $scope.examensRadiologiquesList.push({key:key,label:value});
            });

            $scope.evaluationMaladieList = [] ;
            _.each($scope.constants.evaluation_maladie_list.VALUES_TO_DISPLAY,function(value, key){
                $scope.evaluationMaladieList.push({key:key,label:value});
            });

            $scope.areDatesValid = function()  {
                return $scope.evaluationmaladie.date === null ;
            };

            // -- init
            if ($scope.evaluationmaladie.date) {
                $scope.evaluationmaladie.date = moment($scope.evaluationmaladie.date).hour(12).toDate();
            }








/*
                        $scope.displaySelectedGradeLabel = function(){
                            var index = _.findIndex($scope.selectedGradeLabels,{code:$scope.eicomplication.med_fiche3_ctc_meddra_code});
                            if(index!=-1){
                                $scope.selectedGradeLabel = $scope.selectedGradeLabels[index]['grade'+$scope.eicomplication.med_fiche3_ctc_grade];
                            }
                        };

                        $scope.displaySelectedGradeDescription = function(){
                            $scope.selectedGradeDescription = $scope.constants.grade_complication_chirurgicale_types.VALUES_TO_DESCRIPTION[$scope.eicomplication.chir_fiche4_dindo_grade];
                        };

                        $scope.selectComplicationMed = function($item, $model, $label, $event) {
                            if ($item) {
                                $scope.eicomplication.med_fiche3_ctc_meddra_code = $item.code;
                                $scope.eicomplication.med_fiche3_ctc_meddra_terme = $item.terme;
                                $scope.eicomplication.grade_label = $item.terme;
                            }
                        };


            */

            /**
             * *************************************************************************************************
             * ********************* Initialization
             * *************************************************************************************************
             */
           /* $scope.getComplication('100');
            $scope.displaySelectedGradeDescription();*/


            // /**
            //  * setup the controller
            //  */
            // var initialize = function () {
            // };
            //
            // initialize();
        }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantEvaluationMaladie.js